import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const notificationsPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-notifications',
	path: '/jira/settings/personal/notifications',
};
